import * as PIXI from "pixi.js";
import Game from "../Game";
import Layers from "../layers/Layers";
import { Coord } from "../types/Interface";


export default class Point extends PIXI.Graphics {
  Game = Game.getInstance();
  Layers = Layers.getInstance();
  fillColor: number;
  radius: number = 10;
  
  constructor(coord: Coord, fillColor: number = 0x000000, radius = 10, autoAdd: boolean = true) {
    super();
    Object.assign(this, coord);
    this.fillColor = fillColor;
    this.radius = radius;
    this.eventMode = "none";
    autoAdd && this.addToLayer();
  }
  private addToLayer = () => this.Layers.UI.addChild(this);
  setColor = (color: number) => this.fillColor = color;

  draw(coord: Coord) {
    const dim = this.Game.getDim();
    const isVertical = dim.WIDTH < dim.HEIGHT;

    this.clear();
    Object.assign(this, coord);
    this.circle(0, 0, this.radius)
      .fill({ color: this.fillColor });

    isVertical && this.circle(0, 0, 50)
      .fill({ color: "blue", alpha: 0 })
  }
}